"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_OWNER_TYPE = void 0;
exports.STORE_OWNER_TYPE = {
    MERCHX: 'MERCHX',
    CUSTOMER: 'CUSTOMER'
};
//# sourceMappingURL=storeOwnerType.js.map